import { Tooltip } from 'antd';
import { FC } from 'react';
import { recurringIcon } from '@tools/ui/assets';
import { recurringBillText } from '@tools/ui-utils/recurringBillText.util';
import TableIcon from '../common/icons/tableIcon.icon';

type IProps = {
  recurringBillIndex: number;
  occurrences: number;
};

const RecurringBillIcon: FC<React.PropsWithChildren<IProps>> = ({
  recurringBillIndex,
  occurrences
}) => (
  <Tooltip
    title={recurringBillText(recurringBillIndex, occurrences, true)}
    placement="top"
  >
    <span>
      <TableIcon component={recurringIcon} style={{ marginLeft: 4 }} />
    </span>
  </Tooltip>
);

export default RecurringBillIcon;
